import React from 'react';
import { useTranslation } from 'react-i18next';

function toArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return [];
}

export default function PrivacyPolicy() {
  const { t } = useTranslation();
  const collections = toArray(
    t('info.privacyPage.collections', { returnObjects: true })
  );
  const collectDetails = toArray(
    t('info.privacyPage.collectDetails', { returnObjects: true })
  );
  const sections = toArray(t('info.privacyPage.sections', { returnObjects: true }));
  const partnerBulletPoints = toArray(
    t('info.privacyPage.partnerBulletPoints', { returnObjects: true })
  );
  const adsUsageItems = toArray(
    t('info.privacyPage.adsUsageItems', { returnObjects: true })
  );
  const consentItems = toArray(
    t('info.privacyPage.consentItems', { returnObjects: true })
  );
  const cookieConsentItems = toArray(
    t('info.privacyPage.cookieConsentItems', { returnObjects: true })
  );
  const choicesList = toArray(
    t('info.privacyPage.choicesList', { returnObjects: true })
  );
  const deviceChoices = toArray(
    t('info.privacyPage.deviceChoices', { returnObjects: true })
  );
  const shareList = toArray(t('info.privacyPage.shareList', { returnObjects: true }));
  const optionsList = toArray(
    t('info.privacyPage.optionsList', { returnObjects: true })
  );

  return (
    <div className="container">
      <h1>{t('info.privacyPage.title')}</h1>
      <h2>{t('info.privacyPage.introTitle')}</h2>
      <p>{t('info.privacyPage.introMission')}</p>
      <p>{t('info.privacyPage.introDescription')}</p>

      <h2>{t('info.privacyPage.collectTitle')}</h2>
      {collections.map((section, idx) => {
        const paragraphs = toArray(section.paragraphs);
        return (
          <section key={`collect-${idx}`}>
            <h3>{section.title}</h3>
            {paragraphs.map((paragraph, pIdx) => (
              <p key={`collect-${idx}-p-${pIdx}`}>{paragraph}</p>
            ))}
          </section>
        );
      })}

      <section>
        <h3>{t('info.privacyPage.collectDetailsTitle')}</h3>
        <p>{t('info.privacyPage.collectDetailsIntro')}</p>
        {collectDetails.map(detail => {
          const paragraphs = toArray(detail.paragraphs);
          const items = toArray(detail.items);
          return (
            <div key={detail.key}
            >
              <h4>{detail.title}</h4>
              {paragraphs.map((paragraph, pIdx) => (
                <p key={`${detail.key}-p-${pIdx}`}>{paragraph}</p>
              ))}
              {items.length > 0 && (
                <ul>
                  {items.map((item, itemIdx) => (
                    <li key={`${detail.key}-item-${itemIdx}`}>{item}</li>
                  ))}
                </ul>
              )}
            </div>
          );
        })}
      </section>

      {sections.map((section, idx) => {
        const items = toArray(section.items);
        return (
          <section key={`section-${idx}`}>
            <h3>{section.title}</h3>
            <p>{section.intro}</p>
            <ul>
              {items.map((item, itemIdx) => (
                <li key={`section-${idx}-item-${itemIdx}`}>{item}</li>
              ))}
            </ul>
          </section>
        );
      })}

      <section>
        <h3>{t('info.privacyPage.partnerTitle')}</h3>
        <ul>
          {partnerBulletPoints.map((item, idx) => (
            <li key={`partner-${idx}`}>{item}</li>
          ))}
        </ul>
        <h4>{t('info.privacyPage.adsUsageIntro')}</h4>
        <ul>
          {adsUsageItems.map((item, idx) => (
            <li key={`ads-${idx}`}>{item}</li>
          ))}
        </ul>
        <p>{t('info.privacyPage.consentIntro')}</p>
        <ul>
          {consentItems.map((item, idx) => (
            <li key={`consent-${idx}`}>{item}</li>
          ))}
        </ul>
        <p>{t('info.privacyPage.cookieConsentIntro')}</p>
        <ul>
          {cookieConsentItems.map((item, idx) => (
            <li key={`cookie-${idx}`}>{item}</li>
          ))}
        </ul>
      </section>

      <h2>{t('info.privacyPage.transferTitle')}</h2>
      <p>{t('info.privacyPage.transferParagraph')}</p>

      <h2>{t('info.privacyPage.choicesTitle')}</h2>
      <p>{t('info.privacyPage.choicesIntro')}</p>
      <ul>
        {choicesList.map((item, idx) => (
          <li key={`choice-${idx}`}>{item}</li>
        ))}
      </ul>
      <p>{t('info.privacyPage.choicesSupport')}</p>
      <p>{t('info.privacyPage.choicesDeviceIntro')}</p>
      <ul>
        {deviceChoices.map((item, idx) => (
          <li key={`device-${idx}`}>{item}</li>
        ))}
      </ul>
      <p>{t('info.privacyPage.choicesOutro')}</p>

      <h2>{t('info.privacyPage.shareTitle')}</h2>
      <p>{t('info.privacyPage.shareIntro')}</p>
      <ul>
        {shareList.map((item, idx) => (
          <li key={`share-${idx}`}>{item}</li>
        ))}
      </ul>

      <h2>{t('info.privacyPage.retentionTitle')}</h2>
      <p>{t('info.privacyPage.retentionParagraph')}</p>

      <h3>{t('info.privacyPage.optionsTitle')}</h3>
      <p>{t('info.privacyPage.optionsIntro')}</p>
      <ul>
        {optionsList.map((item, idx) => (
          <li key={`option-${idx}`}>{item}</li>
        ))}
      </ul>
      <p>{t('info.privacyPage.optionsOutro')}</p>

      <h3>{t('info.privacyPage.changesTitle')}</h3>
      <p>{t('info.privacyPage.changesParagraph')}</p>
      <p>
        {t('info.privacyPage.effectiveDate')}
        <br />
        {t('info.privacyPage.lastUpdated')}
      </p>
    </div>
  );
}
